import React from "react";
import LegoL99EData from "../dataDriven/LegoL99EData";
import managingDiabetesCards from "../dataDriven/managingDiabetesCards";

// Live demo: the data-driven L99E renders the same markup as the hand-authored
// L99E lego, but from a {title, pdf, thumb}[] array (here, the real Managing
// Diabetes manifest). 6 cards => 3 + 3.
function L99EDataComponentCode() {
  return (
    <div>
      <LegoL99EData cards={managingDiabetesCards} />
    </div>
  );
}

export default L99EDataComponentCode;
